import { Attr, BelongsTo, HasMany, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import BootSchedule from './boot_schedule';
import WorkstationBoot from './workstation_boot';

@Model()
export default class BootScheduleRun extends ApplicationRecord {
  static jsonapiType = 'boot_schedule_runs';

  @Attr() bootScheduleId: string;
  @Attr() firedDate: string;
  @Attr() firedAt: string;
  @Attr() targetCount: number;
  @Attr() runningCount: number;
  @Attr() bootedCount: number;
  @Attr() completedCount: number;
  @Attr() failedCount: number;
  @Attr() status: string;
  @Attr() createdAt: string;

  @BelongsTo() bootSchedule: BootSchedule;
  @HasMany() workstationBoots: WorkstationBoot[];
}
